import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Input,
  Label,
} from "reactstrap";

const WorkHoursModal = ({ isOpen, onClose, setHours, hours, days ,   storeData,
            mode }) => {

       const [isApplyForAll ,setIsApplyForAll]=useState(false)
  const handleChange = (index, field, value) => {
    console.log('value', value)
    const updated = [...hours];
    if (isApplyForAll && index === 0) {
          updated.forEach((day) => {
      day[field] = value;
    });
    }else{
      
    updated[index][field] = value;
    setHours(updated);
    }

  };
console.log('hours', hours)
  const handleSave = () => {
    const working_days = hours
    .filter((h) => h.open_time || h.close_time).map((h) => ({
      day_of_week: h.day_of_week,
      open_time: h.open_time,
      close_time: h.close_time,
    }));
    setHours(working_days);
    onClose();
  };
  const handleApplyForAll =(e)=>{
 const checked = e.target.checked;
    setIsApplyForAll( e.target.checked)

      if (checked && hours.length > 0) {
    const firstDay = hours[0];
    const updated = hours.map((day) => ({
      ...day,
      open_time: firstDay.open_time,
      close_time: firstDay.close_time,
    }));
    setHours(updated);
  }
  }

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="lg" dir="rtl">
      <ModalHeader toggle={onClose} className="border-0">
        ساعات العمل
      </ModalHeader>

      <ModalBody>
        <p className="text-muted mb-3">حدد ساعات العمل لمتجرك</p>
   
  <Row className="align-items-center mb-2">
    <Col xs="4"><h6>اليوم</h6></Col>
    <Col xs="4"><h6>من</h6></Col>
    <Col xs="4"><h6>إلي</h6></Col>
  </Row>
        {days.map((day, i) => (
          <Row key={day.value} className="align-items-center mb-2">   
            <Col xs="4" className="d-flex gap-5">
              <Label className="fw-semibold">{day.name} </Label>
              {i===0 && <div><label htmlFor="">تطبيق للكل</label> <input type="checkbox"  onChange={handleApplyForAll} /> </div> }
            </Col>
       
            <Col xs="4">
              <input
                type="time"
                 className="form-control"
                step="60"
                value={hours[i].open_time}
                onChange={(e) => handleChange(i, "open_time", e.target.value)}
              />
            </Col>

            <Col xs="4">
              <input
                type="time"
                className="form-control"
                step="60"
                value={hours[i].close_time}
                onChange={(e) => handleChange(i, "close_time", e.target.value)}
              />
            </Col>
          </Row>
        ))}
      </ModalBody>

      <ModalFooter className="justify-content-start">
        <Button color="primary" onClick={handleSave}>
          حفظ
        </Button>
        <button className="btn btn-white" onClick={onClose}>
          إلغاء
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default WorkHoursModal;
